import { RunningExperiments, useExperiments } from 'state/experiments';

export const useEnableCartV2Experiment = (skipExposureLogging: boolean = false) => {
  const { variant } = useExperiments();

  return variant(RunningExperiments.CartV2, 'treatment', {
    skipExposureLogging,
  });
};
